import clsx from 'clsx';
import useTestTag from '../../../common/hooks/use-test-tag';
import OdinIcon, { OdinIconSize } from '../../odin-icon/odin-icon.component';
import type { DropDownResult } from './drop-down-types';

export interface DropDownChipProps {
  value: DropDownResult;
  readOnly?: boolean;
  onRemove: (value: DropDownResult) => void;
  disabled?: boolean;
}

export default function DropDownChip({ value, readOnly, disabled, onRemove }: DropDownChipProps) {
  const chipStyle = clsx(
    'text-mono-1 mr-1 mb-1 pl-2 py-0.5 rounded-sm whitespace-nowrap flex items-center justify-center',
    { 'bg-primary-2 pr-1': !readOnly && !disabled },
    { 'bg-gray-3 pr-2': readOnly || disabled }
  );

  const tagCreator = useTestTag(value.text || '');

  return (
    <div className={chipStyle} ref={tagCreator('option')}>
      {value.text}
      {!readOnly && !disabled && (
        <div className="ml-1 cursor-pointer" onClick={() => onRemove(value)} ref={tagCreator('selected')}>
          <OdinIcon icon="X" size={OdinIconSize.ExtraSmall} />
        </div>
      )}
    </div>
  );
}
